import { Directive, ElementRef, Input } from '@angular/core';
import { AriaElement } from '../aria-element.directive';

/**
 * direttiva da applicare sui componenti ion-img
 * che devono avere un'aria-label che cambia dinamicamente
 */
@Directive({
  selector: '[appAriaImage]'
})
export class AriaImageDirective extends AriaElement<HTMLIonButtonElement> {
  constructor(protected el: ElementRef<HTMLIonButtonElement>) {
    super(el);

    this.adaptHidden = true;
  }

  @Input() set appAriaImage(label: string) {
    this.currentLabel = label;
    this.untillDone.do();
  }

  findElements(): HTMLElement[] {
    return [this.el.nativeElement.shadowRoot.querySelector('img')];
  }
}
